import 'vxe-table-quantdata/lib/style.css'
import Vue from 'vue'
import * as d3 from "d3";
import httpManager from "../../util/common";
import XEUtils from "xe-utils";

Vue.use('vxe-utils');
Vue.use('vxe-table');

let vm = {
  components: {},
  delimiters: ['{', '}'],
  props: {
    report_date: String,
    oaids: Array,
    selectEvent: Boolean,
  },
  data: () => {
    return {
      esg_rating_list: [],
      e_rating_list: [],
      s_rating_list: [],
      g_rating_list: [],
      oaid_data: {},
      official_name:[],
      report_dates:[],
      divloading: false
    }
  },
  methods: {
    getESGData() {
      let promises = []
      let self = this
      self.divloading = true
      self.oaid_data = {}
      for (let m in self.oaids) {
        let params = new Map()
        let oaid = self.oaids[m]
        params.set("oaid", oaid)
        let promise = httpManager("esg_entity_ratings_all", params)
          .then(response => {
            if (response.data.data) {
              self.oaid_data[oaid] = response.data.data.reverse()
              self.divloading = false
            }
          })
          .catch(error => {
            console.log(error)
            self.divloading = false
          })
        promises.push(promise)
      }
      Promise.all(promises).then(function (values) {
        let midData_esg = {}
        let midData_e = {}
        let midData_s = {}
        let midData_g = {}
        self.esg_rating_list = []
        self.e_rating_list = []
        self.s_rating_list = []
        self.g_rating_list = []
        self.official_names = []
        self.report_dates = []
        let eight_hour = 0
        for (let k in self.oaid_data) {
          let data = self.oaid_data[k]
          self.official_names.push(data[0].official_name)
          let count = -1
          for (let j in data) {
            if (count === 12) {
              break
            }
            let sd = data[j]
            let report_date = XEUtils.toDateString(sd.year, 'yyyy-MM-dd')
            if (report_date === self.report_date) {
                count = 0
              }
            if (count !== -1) {
              let date = sd.year - eight_hour
              if(!(date in self.report_dates)){
                self.report_dates.push(date)
              }

              count++
              if (!(report_date in midData_esg)) {
                midData_esg[report_date] = {'date': date}
              }
              midData_esg[report_date][sd.official_name] = self.transGrade(sd.rating)

              if (!(report_date in midData_e)) {
                midData_e[report_date] = {'date': date}
              }
              midData_e[report_date][sd.official_name] = self.transGrade(sd.environmental)

              if (!(report_date in midData_s)) {
                midData_s[report_date] = {'date': date}
              }
              midData_s[report_date][sd.official_name] = self.transGrade(sd.social)

              if (!(report_date in midData_g)) {
                midData_g[report_date] = {'date': date}
              }
              midData_g[report_date][sd.official_name] = self.transGrade(sd.governance)
            }
          }
        }
        for (let i in midData_esg) {
          self.esg_rating_list.push(midData_esg[i])
          self.e_rating_list.push(midData_e[i])
          self.s_rating_list.push(midData_s[i])
          self.g_rating_list.push(midData_g[i])
        }
        self.esg_rating_list = self.esg_rating_list.reverse()
        self.e_rating_list = self.e_rating_list.reverse()
        self.s_rating_list = self.s_rating_list.reverse()
        self.g_rating_list = self.g_rating_list.reverse()
        self.report_dates = self.report_dates.reverse()

        self.drawChart('#esg-multiline-chart-1')
        self.drawChart('#esg-multiline-chart-2')
        self.drawChart('#esg-multiline-chart-3')
        self.drawChart('#esg-multiline-chart-4')
      })
    },
    transGrade(gradeStr) {
      let rating = {
        'AAA': 9,
        'AA': 8,
        'A': 7,
        'BBB': 6,
        'BB': 5,
        'B': 4,
        'CCC': 3,
        'CC': 2,
        'C': 1
      }
      let gradeNum = ['C', 'CC', 'CCC', 'B', 'BB', 'BBB', 'A', 'AA', 'AAA']
      if (typeof (gradeStr) == 'string')
        return rating[gradeStr]
      else {
        return gradeNum[gradeStr - 1]
      }
    },
    drawChart: function (id) {
      let self = this
      let data = null
      if (id === '#esg-multiline-chart-1') {
        data = self.esg_rating_list
      }
      if (id === '#esg-multiline-chart-2') {
        data = self.e_rating_list
      }
      if (id === '#esg-multiline-chart-3') {
        data = self.s_rating_list
      }
      if (id === '#esg-multiline-chart-4') {
        data = self.g_rating_list
      }
      d3.select(id).select('*').remove()
      let width = 700
      let height = 240
      let labelPadding = 6
      let series = self.official_names.map(key => data.map(({[key]: value, date}) => ({key, date, value})))
      let svg = d3.select(id).append("svg").attr("viewBox", [0, 0, width, height])
      let margin = ({top: 40, right: 17, bottom: 47, left: 52})
      let point_count = data.length
      let x = d3.scaleUtc()
        .domain([data[0]['date'], data[point_count-1]['date']]).nice()
        .range([margin.left, width - margin.right - 50])
      let y = d3.scaleLinear().domain([1, 9]).range([height - margin.bottom, margin.top])
      let z = d3.scaleOrdinal(self.official_names, d3.schemeCategory10)

      let xAxis = g => g
        .attr("transform", `translate(0,${height - margin.bottom +13})`)
        .attr("font-size",6)
        .call(d3.axisBottom(x).ticks(point_count).tickFormat(d=>XEUtils.toDateString(d-10*24*60*60*1000, 'yyyy-MM')))
        // .call(g => g.selectAll(".tick text").attr('transform','translate(-19,8)rotate(-30)'))
      let yAxis = g => g
        .attr("transform", `translate(${margin.left},0)`)
        .call(d3.axisLeft(y).tickFormat(d => this.transGrade(d)))
        .call(g => g.select(".domain").remove())
        .call(g => g.select(".tick:last-of-type text").clone()
          .attr("x", 3)
          .attr("text-anchor", "start")
          .attr("font-weight", "bold")
          .text(""))
      svg.append("g").call(xAxis);
      svg.append("g").call(yAxis)
      let serie = svg.append("g")
        .selectAll("g")
        .data(series)
        .join("g");
      serie.append("path")
        .attr("fill", "none")
        .attr("class", d=>"multi-path multi-path-"+d[0].key)
        .attr("name", d=>d[0].key)
        .attr("stroke", d => z(d[0].key))
        .attr("stroke-width", 1.5)
        .attr("d", d3.line()
          .x(d => {
            var tempArray = null
            for(let t in series){
              if(series[t][0].key == d.key)
                tempArray = series[t]
            }
            if(!y(d.value)){
              for(let i =0; i<tempArray.length;i++){
                if(tempArray[i].value){
                  return x(tempArray[i].date)
                }
                  
              }
            }
            return x(d.date)
          })
          .y(d => {
            if(y(d.value))
              return y(d.value)
            else {
              var tempArray = null
              for(let t in series){
              if(series[t][0].key == d.key)
                tempArray = series[t]
                for(let i =0; i<tempArray.length;i++){
                  if(tempArray[i].value){
                    return y(tempArray[i].value)
                  }
                    
                }
              }
            }
          }))
        .on("mouseover", function (d) {
          d3.selectAll(".multi-path").style("opacity", 0.1)
          d3.selectAll(".multi-path-"+d.currentTarget.attributes.name.value).style("opacity", 1)
        })
        .on("mouseout", function (d) {
          d3.selectAll(".multi-path").style("opacity", 1)
        })

      serie.append("g")
        .attr("font-family", "sans-serif")
        .attr("class", d=>"multi-path multi-path-"+d[0].key)
        .attr("font-size", 6)
        .attr("stroke-linecap", "round")
        .attr("stroke-linejoin", "round")
        .attr("text-anchor", "middle")
        .selectAll("text")
        .data(d => d)
        .join("text")
        .text(d => self.transGrade(d.value))
        .attr("dy", "0.35em")
        .attr("x", d => x(d.date))
        .attr("y", d => y(d.value))
        // .call(text => text.filter((d, i, data) => i === data.length - 1)
        //   .append("tspan")
        //   .attr("font-weight", "bold")
        //   .text(d => ` ${d.key}`)
        // )
        .clone(true).lower()
        .attr("fill", "none")
        .attr("stroke", "white")
        .attr("stroke-width", labelPadding)

      let legend = svg => {
        const g = svg
          .attr("transform", `translate(${200},0)`)
          .attr("text-anchor", "end")
          .attr("font-family", "sans-serif")
          .attr("font-size", 6)
          .selectAll("g")
          .data(self.official_names)
          .join("g")
          .attr("transform", (d, i) => `translate(0,${i * 20})`);

        g.append("rect")
          .attr("x", -19)
          .attr("width", 19)
          .attr("height", 19)
          .attr("fill", z);

        g.append("text")
          .attr("x", -24)
          .attr("y", 9.5)
          .attr("dy", "0.35em")
          .text(d => d);

        g.on('mouseover', function (d) {
          d3.selectAll('.multi-path').style('opacity', 0.1)
          let context=d.target.innerHTML||d.path[1].children[1].innerHTML
          d3.selectAll('.multi-path-' + context).style('opacity', 1)
        }).on('mouseout', function (d) {
          d3.selectAll('.multi-path').style('opacity', 1)
        })
      }
      d3.select(id+'-legend').select('*').remove()
      let svg_legend = d3.select(id+'-legend').append("svg").attr("viewBox", [0, 0, 200, height])
      svg_legend.append("g").call(legend);
    },

  },
  mounted() {
  },
  watch: {
    selectEvent: function () {
      this.getESGData()
    }
  },
  created() {
  },
  computed: {
    panes() {
      return [
        {'title': this.$t('esg.esg'),'key': '1','data': null},
        {'title': this.$t('esg.environment'),'key': '2','data': null},
        {'title': this.$t('esg.social_responsibility'), 'key': '3', 'data': null},
        {'title': this.$t('esg.governance'), 'key': '4','data': null}
      ]
    }
  }
}
Vue.component("esg-rating-multi-line-chart", vm)
export default vm



// WEBPACK FOOTER //
// ./src/esg/js/esg_rating_multi_line_chart.js